import { computed, ref } from 'vue'

const WIDGET_DOMAIN = 'transactionlink.io'

const embeddingClientDomain = ref<string>()

const setClientDomain = (domain?: string) => {
    embeddingClientDomain.value = domain
}

const clientDomain = computed(() => embeddingClientDomain.value ?? window.location.hostname)

const embeddedOnWidgetDomain = computed(() =>
    clientDomain.value === WIDGET_DOMAIN || clientDomain.value.endsWith(`.${WIDGET_DOMAIN}`))

function useClientDomain() {
    return {
        clientDomain,
        embeddedOnWidgetDomain,
        setClientDomain,
    }
}

export default useClientDomain
